export default "__VITE_ASSET__YyNCBy6i__";